import React, {ReactNode} from 'react'
import styled from 'styled-components'
import {Colors, FontSize} from '../../../../../styledComponents/Constants'
import {LeftRowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {APPLY_CATEGORY, RESIDENT_APPLY_HISTORY_DIVISION, ROLE_FOR_ADMINISTRATOR} from '../../../../../CodeMaster'
import {InfoOutlinedIcon} from '../admin/NatAdminApplicationCommon'
import {BoldText, WideWhiteArea} from './NatResidentApplicationsCommon'
import moment from 'moment'
import {StyledDiv} from '../../../../../styledComponents/StyledTypeDefinitions'
import {NatGetApplicationResultDetail} from '../../repository/NatGetApplicationResult'
import {getApplicant} from '../helper/NatApplicationHelper'
import {Nullable} from '../../../../../app/TypeHelpers'
import { Box } from '@mui/material';

interface Props {
    applyId: string
    applyHistoryDivision: RESIDENT_APPLY_HISTORY_DIVISION
    applyResultInfo: NatGetApplicationResultDetail
    cardDetail?: Nullable<ReactNode>
}

export const NatResidentApplicationHistoryInfoComponent: React.FC<Props> = props => {
    const {applyId, applyHistoryDivision, cardDetail} = props
    const {applyInfo, resultInfo} = props.applyResultInfo

    const cardInfoApplyDateLabel: string =
        moment(applyInfo.registerDatetime).format('YYYY年M月D日 HH:mm') + '　' + 'に提出'

    const cardInfoApplicantInfoLabel = getApplicant(
        applyInfo.ridgeName,
        applyInfo.roomNumber,
        applyInfo.familyName,
        applyInfo.firstName,
    )

    let historyTitleLabel: string = '';
    switch (applyHistoryDivision) {
        case RESIDENT_APPLY_HISTORY_DIVISION.APPROVED:
            historyTitleLabel = '申請が承認されました。'
            break
        case RESIDENT_APPLY_HISTORY_DIVISION.REJECTION:
            historyTitleLabel = '申請が却下されました。'
            break
    }

    let roleLabel: string = '';
    switch (resultInfo.roleId) {
        case ROLE_FOR_ADMINISTRATOR.ASSOC.value:
            roleLabel = '管理組合'
            break
        default:
            roleLabel = '長谷工コミュニティ'
            break
    }

    return (
        <>
            <WideWhiteArea>
                <Box mt={'10px'}>
                    <CardContainer>
                        <CardContainerStyle>
                            {cardInfoApplyDateLabel}
                        </CardContainerStyle>
                        <CardStatusStyle status={applyHistoryDivision.value}>
                            {applyHistoryDivision.label}
                        </CardStatusStyle>
                    </CardContainer>
                    <Box height={'10px'}/>
                    <Box fontSize={FontSize.Middle}>
                        {applyId}
                    </Box>
                    <Box/>
                    <BoldText>
                        {APPLY_CATEGORY.codeToEnumConstants(applyInfo.applyCategory).label}
                    </BoldText>
                    <Box height={'10px'}/>
                    <Box fontSize={FontSize.Middle}>
                        {cardInfoApplicantInfoLabel}
                    </Box>
                    <Box height={'15px'}/>
                </Box>
            </WideWhiteArea>
            <Box height={'15px'}/>
            {((applyHistoryDivision === RESIDENT_APPLY_HISTORY_DIVISION.APPROVED ||
                    applyHistoryDivision === RESIDENT_APPLY_HISTORY_DIVISION.REJECTION) && resultInfo) &&
                <>
                    <MessagesArea>
                        <Box mt={'10px'}>
                            <LeftRowFlexContainer>
                                <InfoOutlinedIcon style={infoIconStyle}/>
                                <BoldText>{historyTitleLabel}</BoldText>
                            </LeftRowFlexContainer>
                            <Box height={'10px'}/>
                            {cardDetail}
                            {(applyHistoryDivision === RESIDENT_APPLY_HISTORY_DIVISION.APPROVED &&
                                    resultInfo.comment) &&
                                <Box>
                                    <CardContainerStyle>コメント</CardContainerStyle>
                                    <Box fontSize={FontSize.Middle} whiteSpace={'pre-wrap'}>
                                        {resultInfo.comment}
                                    </Box>
                                    <Box height={'20px'}/>
                                </Box>
                            }
                            {applyHistoryDivision === RESIDENT_APPLY_HISTORY_DIVISION.REJECTION &&
                                <Box>
                                    <CardContainerStyle>却下理由</CardContainerStyle>
                                    <Box fontSize={FontSize.Middle} whiteSpace={'pre-wrap'}>
                                        {resultInfo.comment}
                                    </Box>
                                    <Box height={'20px'}/>
                                </Box>
                            }
                            <Box fontSize={FontSize.Small}>
                                {moment(resultInfo.registerDatetime).format('YYYY年M月D日 HH:mm') + '　' +
                                    '確認者：'+ roleLabel}
                            </Box>
                            <Box height={'15px'}/>
                        </Box>
                    </MessagesArea>
                    <Box height={'15px'}/>
                </>
            }
        </>
    )
}

const infoIconStyle = {
    width: '24px',
    height: '24px',
    color: Colors.Primary,
    marginRight: '5px',
}

const MessagesArea = styled.div`
  background-color: ${Colors.Surface};
  padding: 0 10px;
  overflow: hidden;
  box-shadow: 0px 2px 2px 0px rgba(112, 112, 112, 0.4);
  border-radius: 4px;
  overflow-wrap: anywhere;
`

const CardContainerStyle = styled.span`
    color: ${Colors.AccentDark};
    font-size: ${FontSize.Small};
`

const CardStatusStyle = styled.button<{ status?: string }>`
 font-size: ${FontSize.Small};
 color: ${Colors.Surface};
 padding: 0;
 width: 70px;
 border: 0;
 background: ${props => props.status === RESIDENT_APPLY_HISTORY_DIVISION.APPROVED.value ? 'linear-gradient(166deg, #009688 50%, #00838A 50%)'
    : props.status === RESIDENT_APPLY_HISTORY_DIVISION.REJECTION.value ? '#707070' : 'linear-gradient(166deg, #EF6A0B 50%, #CF5A00 50%)'}
`

const CardContainer: StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding-bottom: 5px;
`